module.exports = __webpack_public_path__ + "img/resource.bb67aee2.png";